export default __webpack_public_path__ + "images/0xa219439258ca9da29e9cc4ce5596924745e12b93.png";